import { startCase } from 'lodash';
import moment from 'moment';
import { darken, transparentize } from 'polished';
import { parsePhoneNumber } from 'react-phone-number-input';
import { vendor_routes, view_websites } from './Constants';

export const floristList = [
  {
    id: 1,
    name: 'PlantScape',
  },
  {
    id: 2,
    name: 'Bahma Flowers',
  },
  {
    id: 3,
    name: 'House of Flowers',
  },
];

export const handleErrorImg = async (e) => {
  e.target.onerror = null;
  e.target.src = '';
};

export const initialFilters = {
  size: 20,
  page: 0,
  // query: '',
};

export const getActiveTabId = (tabs) => tabs?.find((t) => t.active).id;
export const getActiveTabName = (tabs) => tabs?.find((t) => t.active)?.name;
export const handleChangeTab = (tabs, clicked) =>
  tabs?.map((p) => {
    return p.id === clicked
      ? {
          ...p,
          active: true,
        }
      : {
          ...p,
          active: false,
        };
  });

export const phoneRegExp =
  /^(\+\d{1,3})?[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
// /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const phoneNumberValue = /^\d*$/;

export const getStatusFriendly = (statusId = 1, obj = {}) =>
  capitalizeFirstLetter(
    startCase(Object.keys(obj).find((key) => key === statusId)),
  );

export const capitalizeFirstLetter = (string) =>
  string
    ? string?.charAt(0)?.toUpperCase() + string?.slice(1)?.toLowerCase()
    : '';

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const getHeightAndWidthWithBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      var image = new Image();
      image.src = fileReader.result;
      image.onload = function () {
        resolve({
          file: fileReader.result,
          width: image.width,
          height: image.height,
        });
      };
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const priceInTwoDecimal = (price) =>
  !isNaN(Number.parseFloat(price)?.toFixed(2))
    ? Number.parseFloat(price)?.toFixed(2)
    : 0;

export const productsNetTotal = (products) =>
  products?.reduce(
    (total, obj) => Number(total) + Number(obj['qty']) * Number(obj['price']),
    0,
  );

export const getDataByArray = (obj = {}, fields = []) =>
  fields
    .map((f) => obj[f])
    .filter((a) => a != null)
    .join(', ')
    .replace(/, *$/, '');

export const underscoreToFriendlyName = (str) => str?.replace(/_/g, ' ');

export const getColor = (color, theme) =>
  color ? theme[color] : theme.primary;

export const getButtonHover = (color, theme) =>
  color && color !== 'secondary' && color !== 'primary'
    ? theme[color]
    : theme.white;

export const getDarkenColor = (color, theme) =>
  darken(0.05, getColor(color, theme));
export const getLightenColor = (color, theme) =>
  transparentize(0.8, getColor(color, theme));

export const ckEditorToolbar = () => {
  return [
    {
      name: 'basicstyles',
      groups: ['basicstyles', 'cleanup'],
      items: [
        'Bold',
        'Italic',
        'Underline',
        'Strike',
        'Subscript',
        'Superscript',
        'RemoveFormat',
      ],
    },
    {
      name: 'document',
      groups: ['mode', 'document', 'doctools'],
      items: ['Source', 'Save', 'NewPage', 'Preview', 'Print', 'Templates'],
    },
    {
      name: 'editing',
      groups: ['find', 'selection', 'spellchecker'],
      items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
    },

    {
      name: 'paragraph',
      groups: ['list'],
      items: ['NumberedList', 'BulletedList'],
    },
    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
    {
      name: 'insert',
      items: [
        'Image',
        'Flash',
        'Table',
        'HorizontalRule',
        'Smiley',
        'SpecialChar',
        'PageBreak',
        'Iframe',
      ],
    },

    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
    { name: 'colors', items: ['TextColor', 'BGColor'] },
    { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
  ];
};

export const randomKey = () => {
  return (Math.random() * 1000000)?.toFixed(0);
};
export const uuidv4 = () => {
  try {
    const cryptoArray = new Uint8Array(16);
    crypto.getRandomValues(cryptoArray);

    cryptoArray[6] = (cryptoArray[6] & 0x0f) | 0x40;
    cryptoArray[8] = (cryptoArray[8] & 0x3f) | 0x80;

    const hexValues = Array.from(cryptoArray, (byte) =>
      byte.toString(16).padStart(2, '0'),
    );

    return `${hexValues.slice(0, 4).join('')}-${hexValues
      .slice(4, 6)
      .join('')}-${hexValues.slice(6, 8).join('')}-${hexValues
      .slice(8, 10)
      .join('')}-${hexValues.slice(10).join('')}`;
  } catch (error) {
    const randomPart = (length) =>
      Math.floor(Math.random() * 2 ** (length * 4))
        .toString(16)
        .padStart(length, '0');
    return `${randomPart(8)}-${randomPart(4)}-4${randomPart(3)}-8${randomPart(
      3,
    )}-${randomPart(12)}`;
  }
};

export const ArrayLengthCheck = (value) => {
  if (value && value?.length > 0) {
    return value;
  } else {
    return [];
  }
};

export const RoleList = () => {
  const role = [
    {
      id: 1,
      name: 'Admin',
    },
    {
      id: 2,
      name: 'Vendor',
    },
  ];
  return role;
};

export const base64Data = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const groupBy = (input, key) => {
  return input.reduce((acc, currentValue) => {
    let groupKey = currentValue[key];
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(currentValue);
    return acc;
  }, {});
};

export const sortDate = (value, keyName) => {
  if (value && value?.length) {
    let filterCommentField = value.slice()?.sort(function (a, b) {
      if (new Date(a[keyName])?.getTime() < new Date(b[keyName]).getTime()) {
        return -1;
      }
      if (new Date(a[keyName])?.getTime() > new Date(b[keyName]).getTime()) {
        return 1;
      }
      return 0;
    });
    return filterCommentField?.reverse();
  } else {
    return [];
  }
};

export const shopNameORProfileImage = (list, userListAPI, userlist, type) => {
  if (type === 'poster') {
    let output = ArrayLengthCheck(userlist)?.find(
      ({ id, username }) =>
        +id === +list?.user_id || username === list?.username,
    );
    let image = '';
    if (output?.username) {
      image = ArrayLengthCheck(userListAPI)?.find(
        ({ discourseUserName }) => discourseUserName === output?.username,
      )?.imageUrl;
      if (image) {
        return image;
      } else {
        image =
          output?.avatar_template?.replace('{size}', '100') ||
          'https://static-00.iconduck.com/assets.00/avatar-default-icon-512x506-lxzxj1en.png';
      }
    }
    return image;
  } else if (type === 'DetailsProfile') {
    let image = '';
    if (list?.username) {
      image = ArrayLengthCheck(userListAPI)?.find(
        ({ discourseUserName }) => discourseUserName === list?.username,
      )?.imageUrl;
      if (image) {
        return image;
      } else if (list?.username === 'system') {
        image =
          'https://global.discourse-cdn.com/basic10/uploads/boostfloral/original/1X/9b7b223f779d6f4e42f01305f3270d0dd3a0e94b.png';
      } else {
        image =
          list?.avatar_template?.replace('{size}', '100') ||
          'https://static-00.iconduck.com/assets.00/avatar-default-icon-512x506-lxzxj1en.png';
      }
    }
    return image;
  } else if (type === 'profile') {
    const posterId = ArrayLengthCheck(list)?.find(({ description }) =>
      description?.includes('Original Poster'),
    );
    const output = ArrayLengthCheck(userlist)?.find(
      ({ id, username }) =>
        +id === +posterId?.user_id || username === posterId?.username,
    );
    let image = '';
    if (output?.username) {
      image = ArrayLengthCheck(userListAPI)?.find(
        ({ discourseUserName }) => discourseUserName === output?.username,
      )?.imageUrl;
      if (image) {
        return image;
      } else {
        image =
          output?.avatar_template?.replace('{size}', '100') ||
          'https://static-00.iconduck.com/assets.00/avatar-default-icon-512x506-lxzxj1en.png';
      }
    }
    return image;
  } else if (type === 'shopName') {
    const posterId = ArrayLengthCheck(list)?.find(({ description }) =>
      description?.includes('Original Poster'),
    );
    const output = ArrayLengthCheck(userlist)?.find(
      ({ id }) => +id === +posterId?.user_id,
    );
    let shopName = 'Floral Shop';
    if (output && output?.username) {
      shopName = ArrayLengthCheck(userListAPI)?.find(
        ({ discourseUserName }) => discourseUserName === output?.username,
      );
      if (shopName) {
        return shopName?.floristDTO?.companyName;
      }
    }
    return shopName;
  } else if (type === 'detailsShopName') {
    let shopName = 'Floral Shop';
    if (list) {
      shopName = ArrayLengthCheck(userListAPI)?.find(
        ({ discourseUserName }) => discourseUserName === list,
      );
      if (shopName) {
        return shopName?.floristDTO?.companyName;
      }
    }
    return shopName;
  }
};

export const topicPosterUserName = (list, user) => {
  const posterId = ArrayLengthCheck(list)?.find(({ description }) =>
    description?.includes('Original Poster'),
  );
  let output = ArrayLengthCheck(user)?.find(
    ({ id, username }) =>
      +id === +posterId?.user_id || username === posterId?.username,
  );
  return output?.username || 'N/A';
};

export const getTheme = (option, customColors) => {
  const [primaryDark, primary, badgeText, primaryLight2] =
    option?.value === 'custom' ? customColors : option?.primaryColors;
  return {
    primary,
    mainPrimary: primary,
    badgeText,
    primaryDark,
    secondaryLight: primaryDark,
    darkenText: primaryDark,
    primaryLight2,
  };
};

export const countStringFromHTMLContent = (value) => {
  const regex = /(<([^>]+)>)/gi;
  return value.replace(regex, '');
};

export const getYear = (date) => moment(date).get('year');
export const getMonth = (date) => moment(date).get('month');

export const SYSTEM_ID = -1;
export const SYSTEM_IMAGE_BASE_URI = 'https://sea1.discourse-cdn.com/basic10/';
export const getUserAvatar = (
  { id, avatar_template } = {},
  size = 36,
  changeSystemImage = true,
) => {
  if (!avatar_template) return '';

  const imageUrl = avatar_template.replace('{size}', size);
  return changeSystemImage && id === SYSTEM_ID
    ? `${SYSTEM_IMAGE_BASE_URI}${imageUrl}`
    : imageUrl;
};

export const groupByProperty = (array, property) => {
  if (!array) return array;

  const result = {};
  array.forEach((item) => (result[item[property]] = item));
  return result;
};

export const getAmount = (amount = 0) =>
  amount.toFixed ? `$${amount?.toFixed(2)}` : amount;

export const IMAGE_PLACEHOLDER =
  'https://www.honeywell.com/content/dam/placeholder-images/mosaic-1-1-placeholder.png';

export const convertHtmlToText = (html) => {
  var tempDivElement = document.createElement('div');
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent || tempDivElement.innerText || '';
};

export const removeHtmlTags = (text) => text.replace(/<\/?[^>]+(>|$)/g, '');
export const formatFileSize = (fileSizeInBytes) => {
  if (fileSizeInBytes < 1024) {
    return fileSizeInBytes + ' B';
  } else if (fileSizeInBytes < 1024 * 1024) {
    return (fileSizeInBytes / 1024)?.toFixed(2) + ' KB';
  } else if (fileSizeInBytes < 1024 * 1024 * 1024) {
    return (fileSizeInBytes / (1024 * 1024))?.toFixed(2) + ' MB';
  } else {
    return (fileSizeInBytes / (1024 * 1024 * 1024))?.toFixed(2) + ' GB';
  }
};

export const convertToNumber = (inputValue) => {
  if (!inputValue) return 0;
  if (!isNaN(inputValue)) {
    const numericValue = parseFloat(inputValue);

    return numericValue;
  }

  return 0;
};

export function isGifImage(imageUrl) {
  try {
    // Extract the file extension from the URL
    const fileExtension = imageUrl?.split('.').pop().toLowerCase();

    // Check if the file extension indicates a GIF
    return fileExtension === 'gif';
  } catch (error) {
    return false; // Handle errors and return false
  }
}

export const hexToRgbA = (hex, opacity = 0.1) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return (
      'rgba(' +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
      ',' +
      opacity +
      ')'
    );
  }
  return 'rgba(255,255,255,1)';
};

export function formatPhone(phoneNumber) {
  if (phoneNumber === null || phoneNumber === undefined) {
    return '';
  }

  const countryCode = phoneNumber.includes('+1')
    ? '+1'
    : phoneNumber?.substring(0, 3);
  const phoneDigits = phoneNumber.substring(countryCode?.length);

  const formattedNumber = phoneDigits.replace(
    /(\d{3})(\d{3})(\d{4})/,
    '($1) $2-$3',
  );

  return `${countryCode} ${formattedNumber}`;
}

export function validatePhoneNumberForFormik(number) {
  if (!number) return false;
  const phoneNumber = parsePhoneNumber(number);
  const cleanedNumber = number.replace(/\D/g, '');

  if (
    /^(\+?1|001)?[2-9]\d{9}$/.test(cleanedNumber) ||
    (phoneNumber && phoneNumber?.isValid())
  ) {
    return true;
  }

  return false;
}

export function removeFileNameDots(filename) {
  if (!filename) return '';
  let lastDotIndex = filename.lastIndexOf('.');
  let name = filename.substring(0, lastDotIndex).replace(/\./g, '');
  let extension = filename.substring(lastDotIndex);

  let newFilename = name + extension;

  return newFilename;
}

export const getBugsnagKey = () => {
  return process.env.REACT_APP_Bugsnag_APIKEY;
};

export const formatLocaleNumber = (num, locale = 'en-US', options = {}) => {
  const formatter = new Intl.NumberFormat(locale, options);
  if (num === undefined || num === null) return '-';
  if (num === 0) return '0.00';
  return formatter.format(num);
};

export const isEmoji = (char) => char.length > 1 || char.charCodeAt(0) > 127359; // Check if the character is outside the Basic Multilingual Plane (BMP) range

export const encodeToHtmlEntity = (message) =>
  Array.from(message)
    .map((char) =>
      isEmoji(char) ? `&#x${char.codePointAt(0).toString(16)};` : char,
    )
    .join('');

// Decode HTML entities including emojis
export const decodeHtmlEntity = (encodedString) =>
  encodedString.replace(/&#(?:x([\da-fA-F]+)|(\d+));/g, (match, hex, dec) => {
    const codePoint = hex ? parseInt(hex, 16) : parseInt(dec, 10);
    return String.fromCodePoint(codePoint);
  });

export const calculateTransformValues = (
  imageWidth,
  imageHeight,
  parentWidth,
  parentHeight,
) => {
  // Calculate scaling factor based on whether image should fill width or height
  const scaleWidth = parentWidth / imageWidth;
  const scaleHeight = parentHeight / imageHeight;
  const scale = Math.min(scaleWidth, scaleHeight);

  // Calculate scaled dimensions
  const scaledWidth = imageWidth * scale;
  const scaledHeight = imageHeight * scale;

  // Calculate translated position to center the image
  const translateX = (parentWidth - scaledWidth) / 2;
  const translateY = (parentHeight - scaledHeight) / 2;

  return {
    scale: scale,
    translation: {
      x: translateX,
      y: translateY,
    },
  };
};

export const getNameFromURL = (url) => {
  // Create a URL object
  const parsedUrl = new URL(url);

  // Get the pathname from the URL
  const pathname = parsedUrl.pathname;

  // Split the pathname by '/'
  const parts = pathname.split('/');

  // The last part should be the filename
  return parts[parts.length - 1];

  // Extract the name by removing the file extension
  // return filename.split('.')[0];
};

export const generateUploadFileName = (file) => {
  const lastIndexOfDot = file.name.lastIndexOf('.');
  const name = file.name.substring(0, lastIndexOfDot);
  const extension = file.name.substring(lastIndexOfDot + 1);
  const currentMilli = new Date().getTime();
  const result = `${name}-${file.size}-${currentMilli}.${extension}`;
  return result;
};

export const calculateProgress = (value, maxLength) => {
  if (!value || !maxLength) return 0;
  return (value.length / maxLength) * 100;
};

export const findMissingZipCodes = (chargesSettings, zipCodesList) => {
  const deliveryZipCodes = zipCodesList?.map((item) => ({
    ...item,
    zipCode: Array.isArray(item?.zipCode)
      ? [...new Set(item?.zipCode?.filter((zip) => zip?.trim() !== ""))]
      : item?.zipCode,
  }));

  const newZipcodeList = deliveryZipCodes?.flatMap((item) => item?.zipCode);
  const missingZipCodes = chargesSettings
    .filter((item) => !newZipcodeList.includes(item?.zipCode))
    .map((item) => item?.zipCode);
  return missingZipCodes;
};

/**
 * Formats a given timestamp into a string representation of the date and time
 * in the format: YYYY-MM-DD HH:MM:SS
 *
 * @param {string|number} timestamp - The timestamp to be formatted. Can be a string or a number.
 * @return {string} The formatted date and time string.
 */
export const formatTimestamp = (timestamp) => {
  // Parse the timestamp into a Date object
  const date = new Date(parseInt(timestamp, 10));

  // Extract the individual components of the date and time
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Combine the components into the desired format
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const checkImageURL = (imageUrl , heroImage = false) => {
  return new Promise((resolve) => {
    const startTime = Date.now();
    const timeoutDuration = heroImage ? 120000 : 60000; // 1 minute in milliseconds

    const checkImage = () => {
      const img = new Image();

      img.onload = () => {
        resolve(true);
      };

      img.onerror = (error) => {
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= timeoutDuration) {
          resolve(false);
        } else {
          setTimeout(checkImage, 1000); // Check again after 1 second
        }
      };

      img.src = imageUrl;
    };

    checkImage();
  });
};

export const checkVideoURL = (videoUrl) => {
  return new Promise((resolve) => {
    const startTime = Date.now();
    const timeoutDuration = 60000; // 1 minute in milliseconds

    const checkVideo = () => {
      const video = document.createElement('video');

      video.onloadeddata = () => {
        resolve(true);
      };

      video.onerror = () => {
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= timeoutDuration) {
          resolve(false);
        } else {
          setTimeout(checkVideo, 1000); // Check again after 1 second
        }
      };

      video.src = videoUrl;
      video.load();
    };

    checkVideo();
  });
};

export const calculateServiceFee = (price) => {
  if (price) {
    const fee = parseFloat(price) * 0.04;
    return fee < 5.99 ? 5.99 : fee.toFixed(2);
  } else {
    return 5.99;
  }
};

export const getOrdinalSuffix = (num) => {
  if (num > 3 && num < 21) return 'th';
  switch (num % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const getDayLabel = (day) => {
  if (!day) return '';
  return `${day}${getOrdinalSuffix(day)}`;
};

export const scrollToFirstError = (errors) => {
  if (errors) {
    for (const key in errors) {
      if (errors[key]) {
        const element = document.querySelector(`[id="${key}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus();
          break;
        }
      }
    }
  }
};

export const isAuthorized = (arr, value) => {
  return arr.some((item) => item?.name === value && item?.enabled);
};

export const isDisabled = (userPermissions, link, roles) => {
  const isVendor = roles?.some((role) => role?.id === 2);
  const isFloristLink = vendor_routes.some((route) => route?.link === link);
  const permission = view_websites.find((perm) => perm?.link === link);

  if (isVendor) {
    if (isFloristLink) {
      // If the role is a Vendor and the link is in isFloristLink, it should be visible to the Vendor
      return false; // Not disabled
    } else {
      // If the role is a Vendor and the link is NOT in isFloristLink, use the permissions check
      return (
        permission &&
        !userPermissions.some(
          (userPerm) =>
            userPerm?.name === permission?.name && userPerm?.enabled,
        )
      );
    }
  }

  // If not a Vendor and the link is in isFloristLink, disable it
  if (isFloristLink) return true;

  // For non-Vendor roles and other cases, check permissions
  return (
    permission &&
    !userPermissions.some(
      (userPerm) => userPerm?.name === permission?.name && userPerm?.enabled,
    )
  );
};

export const isDisabledFunction = (userPermissions, permission) => {
  return (
    permission &&
    !userPermissions.some(
      (userPerm) => userPerm?.name === permission?.name && userPerm?.enabled,
    )
  );
};

export const getName = (location) => {
  if (
    location.pathname === '/settings/products' ||
    location.pathname === '/settings/products/catalog'
  ) {
    return 'product';
  } else if (location.pathname === '/products') {
    return 'catalogue';
  } else {
    return 'globalCatalogue';
  }
};

export const formatNumber = (h) => {
  if (typeof h === 'string') {
    h = parseFloat(h);
  }

  // Check if h is a valid number
  if (typeof h === 'number' && !Number.isNaN(h) && Number.isFinite(h)) {
    return h.toFixed(2);
  } else {
    return '';
  }
};

export const getPrices = (product, variationKey) => {
  const price = product[variationKey]?.length
    ? product[variationKey].find((item) => item.defaultVariation)?.price ??
      product[variationKey][0].price
    : product.price ?? '';

  const originalPrice = product[variationKey]?.length
    ? product[variationKey].find((item) => item.defaultVariation)
        ?.originalPrice ?? product[variationKey][0].originalPrice
    : product.originalPrice ?? '';

  const oldPrice = product[variationKey]?.length
    ? product[variationKey].find((item) => item.defaultVariation)?.oldPrice ??
      product[variationKey][0].oldPrice
    : product.oldPrice ?? '';

  const isDiscountApplied = product[variationKey]?.length
    ? product[variationKey]?.find((item) => item.defaultVariation)
        ?.discountPriceApplied
    : product.discountPriceApplied;

  const isHolidayPriceApplied = product[variationKey]?.length
    ? product[variationKey]?.find((item) => item.defaultVariation)
        ?.holidayPriceApplied
    : product.holidayPriceApplied;

  const discountPrice = product[variationKey]?.length
    ? product[variationKey]?.find((item) => item.defaultVariation)
        ?.discountPrice
    : product.discountPrice;

  const holidayPrice = product[variationKey]?.length
    ? product[variationKey]?.find((item) => item.defaultVariation)?.holidayPrice
    : product.holidayPrice;

  return {
    price,
    originalPrice,
    oldPrice,
    isDiscountApplied,
    isHolidayPriceApplied,
    discountPrice,
    holidayPrice,
  };
};

export const highlightText = (text, query) => {
  if (!query) return text; // Return original text if there's no query

  // Create a regular expression to find all occurrences of the query (case-insensitive)
  const regex = new RegExp(`(${query})`, 'gi');

  // Split the text and wrap matching words in a <span>
  const parts = text.split(regex);
  return parts.map((part, index) =>
    regex.test(part) ? (
      <span key={index} style={{ backgroundColor: 'yellow' }}>
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export const isEmptyOrNullObj = (obj) => {
  if (obj === null || obj === undefined) {
    return true;
  }

  if (Object.keys(obj).length === 0) {
    return true;
  }

  return false;
};

const hexToRgb = (hex) => {
  // Remove the hash (#) if present
  hex = hex.replace(/^#/, '');

  // Parse the hex string into RGB values
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return { r, g, b };
};

export const contrastRatio = (hexa1, hexa2) => {
  const hexatoRbg1 = hexToRgb(hexa1);
  const luminance1 = [hexatoRbg1.r, hexatoRbg1.g, hexatoRbg1.b].map(function (
    v,
  ) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  const l1 =
    luminance1[0] * 0.2126 + luminance1[1] * 0.7152 + luminance1[2] * 0.0722;

  const hexatoRbg2 = hexToRgb(hexa2);
  const luminance2 = [hexatoRbg2.r, hexatoRbg2.g, hexatoRbg2.b].map(function (
    v,
  ) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  const l2 =
    luminance2[0] * 0.2126 + luminance2[1] * 0.7152 + luminance2[2] * 0.0722;

  const contrastRatioValue =
    (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);

  const finalContrastRatioValue = parseFloat(contrastRatioValue.toFixed(1));

  if (finalContrastRatioValue >= 4.5) {
    return {
      value: finalContrastRatioValue,
      bool: true,
    };
  } else {
    return {
      value: finalContrastRatioValue,
      bool: false,
    };
  }
};

export const duplicateZipcodes = (allZipCodes) => {
  const zipCodeCounts = allZipCodes.reduce((acc, zip) => {
    acc[zip] = (acc[zip] || 0) + 1;
    return acc;
  }, {});

  // Filter zip codes that appear more than once
  const finalDuplicateZipCodes = Object.keys(zipCodeCounts).filter(
    (zip) => zipCodeCounts[zip] > 1,
  );

  return finalDuplicateZipCodes;
};

export const sortArray = (value) => {
  if (value && value?.length > 0) {
   return [...value].sort((a, b) => a.name.localeCompare(b.name));;
  } else {
    return [];
  }
};

export const websiteUrl = (websiteName) => {
  if (!websiteName) return '';

  if(websiteName.includes('localhost')) {
    return websiteName
  }
  
  try {
    let url = new URL(websiteName.startsWith("http") ? websiteName : `https://${websiteName}`);


    
    // Ensure it includes "www."
    if (!url.hostname.startsWith("www.")) {
      url.hostname = `www.${url.hostname}`;
    }

    // Ensure it ends with "/"
    let modifiedWebsite = url.toString();

    return modifiedWebsite;
  } catch (error) {
    return websiteName; // Return as is if URL construction fails
  }
};

export const rgbToHex = (rgb) => {
  if (!rgb || !rgb.startsWith("rgb")) return rgb;

  const rgbValues = rgb
    .replace(/[^\d,]/g, "")
    .split(",")
    .map(Number);

  return (
    "#" +
    rgbValues
      .map((val) => val.toString(16).padStart(2, "0"))
      .join("")
  );
};


export const timeAgo = (date) => {
  const now = new Date();
  const postDate = new Date(date);
  const differenceInSeconds = Math.floor((now - postDate) / 1000);

  const days = Math.floor(differenceInSeconds / (3600 * 24));
  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;

  const hours = Math.floor(differenceInSeconds / 3600);
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;

  const minutes = Math.floor(differenceInSeconds / 60);
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;

  return 'Just now';
};

export const timeAgo2 = (date) => {
  const now = new Date();
  const postDate = new Date(date);
  const differenceInSeconds = Math.floor((now - postDate) / 1000);

  const minutes = Math.floor(differenceInSeconds / 60);
  const hours = Math.floor(differenceInSeconds / 3600);
  const days = Math.floor(differenceInSeconds / (3600 * 24));
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) return `${years} year${years > 1 ? 's' : ''} ago`;
  if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
  if (weeks > 0 && days >= 7) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;

  return 'Just now';
};

 export const formatDateTime = (dateString) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };

    return new Date(dateString).toLocaleString('en-US', options);
  };

